export const SET_IS_ONLINE = 'SET_IS_ONLINE' as 'SET_IS_ONLINE'
export const SET_LOADING = 'SET_LOADING' as 'SET_LOADING'
export const UNSET_LOADING = 'UNSET_LOADING' as 'UNSET_LOADING'
